import DOMPurify from 'dompurify';

// For inline HTML fragments (bold, italic, links, simple formatting)
export function sanitizeInlineHTML(dirty) {
  if (!dirty) return '';
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: ['strong', 'em', 'b', 'i', 'a', 'br', 'span', 'code'],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'style'],
  });
}

// For rich HTML content (template results, dashboards, reports)
export function sanitizeRichHTML(dirty) {
  if (!dirty) return '';
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: [
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'div', 'span',
      'table', 'thead', 'tbody', 'tfoot', 'tr', 'th', 'td', 'caption', 'colgroup', 'col',
      'ul', 'ol', 'li', 'dl', 'dt', 'dd',
      'strong', 'em', 'b', 'i', 'a', 'br', 'hr', 'img', 'code', 'pre', 'blockquote',
      'section', 'article', 'header', 'footer', 'nav', 'main',
      'style',
      'svg', 'path', 'g', 'rect', 'circle', 'ellipse', 'line', 'polyline', 'polygon', 'text', 'tspan', 'defs', 'use', 'symbol',
    ],
    ALLOWED_ATTR: [
      'class', 'style', 'id',
      'href', 'target', 'rel', 'src', 'alt', 'title',
      'width', 'height', 'colspan', 'rowspan', 'scope',
      'viewBox', 'd', 'fill', 'stroke', 'stroke-width', 'stroke-dasharray', 'transform',
      'x', 'y', 'x1', 'y1', 'x2', 'y2', 'cx', 'cy', 'r', 'rx', 'ry',
      'font-size', 'text-anchor', 'dominant-baseline', 'alignment-baseline',
      'points', 'opacity', 'fill-opacity', 'stroke-opacity',
    ],
    ALLOW_DATA_ATTR: false,
  });
}
